import "./App.css";
import "../src/common/Assets/styles/Style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import RctRoutes from "./RctRoutes";
import { useEffect, useState } from "react";
import HttpClient from "./Services/HttpClient";
import { Toaster } from "react-hot-toast";
import Loader from "./Components/Loader";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AutoClearStorage from "./Components/AutoClearStorage";

function App() {
  const { pathname } = useLocation();
  const splitPath = pathname?.split("/");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const loaderDisable = ["home", "e-library", "live-sessions", "subscription"];
  const alertMessage = useSelector((state) => state.alertMessage);

  useEffect(() => {
    if (token) {
      HttpClient.defaults.headers.common["Authorization"] =
        `Bearer ${token}` || "";
    }

    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
  }, []);

  return (
    <div>
      
      <AutoClearStorage>
      {/* {loading && !loaderDisable?.includes(splitPath?.[1]) && <Loader />} */}
      <Toaster position={alertMessage == "You have already logged in on another device" ? "top-center" : "top-right"} reverseOrder={false} />
      <RctRoutes />
       </AutoClearStorage>
    </div>
  );
}

export default App;
